<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label class="text-info" v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           class="form-control"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :value="value"
           v-mask="'(99)99999-999[9]'"
           @input="updateValue($event.target.value)"
           @blur="updateValue($event.target.value)"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputPhone',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error', 'disabled'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputPhone.vue?0a829808